// src/components/About.js

import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <h2>About OJ Mechanisms</h2>
      <p>
        Welcome to OJ Mechanisms, your trusted source for high-quality vehicles. We pride ourselves on offering a wide selection of cars, trucks, and SUVs at competitive prices. Our dedicated team is here to assist you every step of the way, ensuring a seamless buying experience.
      </p>
      <p>
        At OJ Mechanisms, we believe in providing exceptional customer service and building long-lasting relationships with our clients. Whether you're looking for a new or used vehicle, we are committed to helping you find the perfect fit for your needs.
      </p>
      <p>
        Visit us today to explore our inventory and experience the OJ Mechanisms difference!
      </p>
      <section className="mission-vision">
        <h2>Our Mission</h2>
        <p>
          Our mission is to provide our customers with an exceptional car buying experience, 
          offering quality vehicles and excellent customer service.
        </p>

        <h2>Our Vision</h2>
        <p>
          We envision a future where every customer finds their ideal vehicle through our 
          innovative platform and personalized services.
        </p>

        <h2>Our Motto</h2>
        <p>
          "Drive Your Dreams with OJ Mechanisms"
        </p>
      </section>
    </div>
  );
};

export default About;
